import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { debounce } from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { useGetConsumerApplicationsV1LocationsSearchFullQuery, } from 'consumer-applications-v1-api';
import icon from 'images/utility-icons/search.svg';
import Results from './Results';
import ResultsWrapper from './ResultsWrapper';
function PracticeSearchForm({ handleSubmit, useStyle = true, displayOptions = {
    showPrequalify: true,
    placeholder: 'Practice Name, Address, or Phone Number',
}, }) {
    // State
    const [searchCriteria, setSearchCriteria] = useState('');
    // Debounce — only the search term is debounced; the query reacts to it.
    const setSearchCriteriaDebounced = useMemo(() => debounce(setSearchCriteria, 500), []);
    // Cancel any pending debounced update on unmount so it can't set state after
    // the component is gone (matches ProviderSearchCard).
    useEffect(() => () => setSearchCriteriaDebounced.cancel(), [setSearchCriteriaDebounced]);
    const { data: practiceLocationSuggestions = [] } = useGetConsumerApplicationsV1LocationsSearchFullQuery({ searchCriteria, fieldsToSearch: 'all', limit: 5 }, { skip: !searchCriteria });
    // Func - submit
    const onSubmit = (e) => {
        e.preventDefault();
        handleSubmit(e);
    };
    // Func - click
    const handleClick = (item) => {
        handleSubmit(item);
    };
    const findPractice = (e) => {
        if (e.target.value && e.target.value !== '') {
            setSearchCriteriaDebounced(e.target.value);
        }
        else {
            // Cancel any in-flight debounced update so a stale value can't repopulate
            // searchCriteria (and re-trigger the query) after the field is cleared.
            setSearchCriteriaDebounced.cancel();
            setSearchCriteria('');
        }
    };
    return (_jsx("form", { className: "results", noValidate: true, onSubmit: onSubmit, children: _jsxs("div", { className: "practice-search-wrapper", style: { zIndex: 1000 }, children: [_jsx("img", { src: icon, className: "magGlass", alt: "search" }), _jsx("input", { name: "searchCriteria", placeholder: displayOptions.placeholder, onChange: findPractice, type: "search" }), _jsx(ResultsWrapper, { useStyle: useStyle, children: _jsx(Results, { handleClick: handleClick, results: practiceLocationSuggestions, showPrequalify: displayOptions.showPrequalify }) })] }) }));
}
export default PracticeSearchForm;
